/**
 * ControllerIcon - Section header icon for the controller: the power board enclosure
 * (front silhouette from the masterpower-in-cap CAD model — wide upper body, narrower
 * lower body offset right) with the phone sitting in its large window.
 * Drawn on the 24px grid with a 2px rounded stroke to match Material Symbols Rounded (wght 400).
 */

interface ControllerIconProps {
  /** Icon size in pixels (default 18, same as the section header Material icons) */
  size?: number;
}

export const ControllerIcon: React.FC<ControllerIconProps> = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    style={{ display: 'block', flexShrink: 0 }}
  >
    {/* Enclosure outline */}
    <path
      d="M5 5H19A2 2 0 0 1 21 7V17A2 2 0 0 1 19 19H10A2 2 0 0 1 8 17V15A1 1 0 0 0 7 14H5A2 2 0 0 1 3 12V7A2 2 0 0 1 5 5Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    {/* Phone in the window */}
    <rect x={6} y={7.5} width={12} height={4} rx={1} fill="currentColor" />
  </svg>
);
